/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useRegisterSW } from 'virtual:pwa-register/react';

/** Wraps vite-plugin-pwa registration; surfaces the "new version" state and a manual reload trigger. */
export function useServiceWorkerUpdate() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  return {
    needRefresh,
    update: () => updateServiceWorker(true),
    close: () => setNeedRefresh(false),
  };
}
